import {Show} from 'platform/foundation';

import {ReactNode} from 'react';

import {isNotNilOrEmpty} from 'ramda-adjunct';

import {suffixTestId, TestIdProps} from 'shared/web';

export interface DropdownGroupProps extends TestIdProps {
  label?: string;
  children: ReactNode;
}

export function DropdownGroup(props: DropdownGroupProps) {
  return (
    <div data-testid={suffixTestId('dropdownGroup', props)}>
      <Show when={isNotNilOrEmpty(props.label)}>
        <p className="m-0 px-2 py-1 text-[length:var(--text-size-x-small)] font-[var(--font-weight-regular)] leading-[var(--text-leading-x-small)] tracking-[0] text-[var(--color-secondary)]">
          {props.label}
        </p>
      </Show>
      {props.children}
    </div>
  );
}
